import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ENV_VARS } from "@/constants/env";
import { APIEndpoints } from "@/constants/apiEndpoints";
import type { IApiResponse } from "@/types";
import type {
  IPublicDigitalIdPayload,
  ISubmitDigitalIdContactPayload,
} from "@/types/digital-id.interface";

export const publicDigitalIdApi = createApi({
  reducerPath: "publicDigitalIdApi",
  baseQuery: fetchBaseQuery({ baseUrl: ENV_VARS.API_INSTANCE }),
  endpoints: (builder) => ({
    resolveDigitalId: builder.query<
      IApiResponse<IPublicDigitalIdPayload>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: APIEndpoints.PublicDigitalId.Resolve(id),
      }),
    }),
    submitDigitalIdContact: builder.mutation<
      IApiResponse<{ successMessage: string }>,
      { id: string } & ISubmitDigitalIdContactPayload
    >({
      query: ({ id, ...body }) => ({
        url: APIEndpoints.PublicDigitalId.Contact(id),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useResolveDigitalIdQuery, useSubmitDigitalIdContactMutation } =
  publicDigitalIdApi;
